import EventRepository from "./contents/EventRepository";
import OauthUserRepository from "./contents/OauthUserRepository";
import RankingRunnerRepository from "./contents/RankingRunnerRepository";

const repositories = {
  event: EventRepository,
  oauth: OauthUserRepository,
  ranking: RankingRunnerRepository,
};

export const RepositoryFactory = {
  get: (name) => repositories[name],
};



// WEBPACK FOOTER //
// ./src/api/RepositoryFactory.js